export const testimonials = [
  {
    id: 1,
    name: '林女士',
    location: '北京',
    avatar: 'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20woman%20portrait%20warm%20soft%20lighting%20neutral%20background%20simple%20clean%20professional&width=120&height=120&seq=testimonial-avatar-01&orientation=squarish',
    quote: '白洁的故事让我看到了自己的影子。作为一个结婚十年的女性，我在这部作品中找到了被理解的温暖。强烈推荐给每一位在婚姻中感到迷茫的女性。',
  },
  {
    id: 2,
    name: '王女士',
    location: '上海',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20woman%20portrait%20with%20warm%20smile%20soft%20studio%20lighting%20clean%20background%20elegant&width=120&height=120&seq=testimonial-avatar-02&orientation=squarish',
    quote: '第一次读到白洁的时候就哭了，感觉自己所有说不出口的话都被写了出来。谢谢作者创造了这样一个真实而鲜活的角色。',
  },
  {
    id: 3,
    name: '陈女士',
    location: '广州',
    avatar: 'https://readdy.ai/api/search-image?query=Warm%20portrait%20of%20Chinese%20woman%20with%20gentle%20expression%20soft%20natural%20light%20clean%20neutral%20background%20simple&width=120&height=120&seq=testimonial-avatar-03&orientation=squarish',
    quote: '这个网站的情感和文学分析做得非常好，每一篇文章都让人有所思。我每周都会来看看有没有新的内容更新。',
  },
  {
    id: 4,
    name: '赵女士',
    location: '成都',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20woman%20portrait%20with%20confident%20expression%20warm%20lighting%20simple%20neutral%20background%20professional%20headshot&width=120&height=120&seq=testimonial-avatar-04&orientation=squarish',
    quote: '不只是情感故事，更是一部女性成长启示录。白洁教会我勇敢面对自己的内心，这是我读过最有力量的故事之一。',
  },
];